import { render } from "./EventPreview.vue?vue&type=template&id=01dac2a9&scoped=true"
import script from "./EventPreview.vue?vue&type=script&lang=js"
export * from "./EventPreview.vue?vue&type=script&lang=js"

import "./EventPreview.vue?vue&type=style&index=0&id=01dac2a9&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\babay\\Documents\\GitHub\\gosociali-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01dac2a9"],['__file',"resources/js/views/Event/Preview/EventPreview.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "01dac2a9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('01dac2a9', __exports__)) {
    console.log('reload')
    api.reload('01dac2a9', __exports__)
  }
  
  module.hot.accept("./EventPreview.vue?vue&type=template&id=01dac2a9&scoped=true", () => {
    console.log('re-render')
    api.rerender('01dac2a9', render)
  })

}


export default __exports__